import styled from 'styled-components/macro';

const GameTitle = styled.div`
  color: hsl(0, 0%, 100%);
  display: flex;
  flex-direction: column;
  font-size: 3rem;
  font-weight: bold;
  line-height: 0.8;
`;

export default GameTitle;
